import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function Questions() {
  const { t } = useLanguage();
  const [openId, setOpenId] = useState<number | null>(0);

  const faqs = [
    { id: 0, q: t('questions.q1'), a: t('questions.a1') },
    { id: 1, q: t('questions.q2'), a: t('questions.a2') },
    { id: 2, q: t('questions.q3'), a: t('questions.a3') },
  ];

  return (
    <div className="p-6 md:p-10 max-w-4xl mx-auto h-full">
      <div className="mb-10 text-center">
        <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4">{t('questions.title')}</h1>
        <div className="h-1 w-20 bg-goszakup-600 mx-auto rounded"></div>
      </div>

      <div className="space-y-4">
        {faqs.map((faq) => (
          <div 
            key={faq.id} 
            className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-200"
          >
            <button
              onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors"
            >
              <span className="font-bold text-lg text-gray-900">{faq.q}</span>
              {openId === faq.id ? (
                <ChevronUp className="w-6 h-6 text-goszakup-600 flex-shrink-0 ml-4" />
              ) : (
                <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0 ml-4 hover:text-goszakup-600" />
              )}
            </button>
            
            <div 
              className={`transition-all duration-300 ease-in-out px-6 text-gray-600 leading-relaxed ${
                openId === faq.id ? 'py-5 border-t border-gray-100 bg-gray-50/50' : 'h-0 py-0 opacity-0 overflow-hidden'
              }`}
            >
              {faq.a}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-blue-50 border border-blue-100 rounded-2xl p-8 text-center text-blue-900">
        <h3 className="font-bold text-xl mb-2">Не нашли ответ на свой вопрос? / Сұрағыңызға жауап таппадыңыз ба?</h3>
        <p className="mb-6 opacity-80">Свяжитесь с нами через страницу Контакты. / Бізбен "Байланыстар" парақшасы арқылы хабарласыңыз</p>
        <a href="/contacts" className="inline-block bg-white text-goszakup-600 px-6 py-2 rounded-lg font-bold shadow-sm hover:shadow transition transform hover:-translate-y-0.5">
          Перейти на страницу / Өту
        </a>
      </div>
    </div>
  );
}